
export default function Services() {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold text-green-800">Our Services</h2>
      <ul className="mt-4 list-disc list-inside space-y-2">
        <li>Internal medicines</li>
        <li>Cupping therapy</li>
        <li>Varma (Stimulation of energy points)</li>
        <li>Nashyam (Nasal application)</li>
        <li>Puravalaiya sikichai (Oil pooling in dough)</li>
        <li>Vethu (Steam therapy) & Pugai (Fumigation)</li>
        <li>Ottradam (Fomentation)</li>
        <li>Patru (Poultice) & Kattu (Bandage)</li>
        <li>Seelai (Medicated gauze)</li>
        <li>Kalimbu (Ointment), Pasai (Cream), Kali (Paste)</li>
        <li>Ayurvedic Cosmetics</li>
      </ul>
    </div>
  );
}